import { useGridApiRef } from "@mui/x-data-grid";
import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import useAPI from "../../../../../api/hooks/useAPI";
import { controlKeys } from "../../../../../api/queryKeys";
import LoadingIcon from "../../../../../components/LoadingIcon";
import { generateFileName } from "../../../../../hooks/useFileNaming";
import WidgetWrapper from "../../WidgetWrapper";
import ControlsTableWidget from "./ControlsTableWidget";
import { filterTeamTasks } from "./utils/controlFilters";

const TeamTasks = () => {
  const { trackEvent, fetchAllControls } = useAPI();
  const gridRef = useGridApiRef();
  const navigate = useNavigate();
  const { data: controls, isLoading: loadingControls } = useQuery({
    queryKey: controlKeys.all,
    queryFn: fetchAllControls,
    select: (data) =>
      data.data.map((control) => ({
        ...control,
        id: control.control_id,
      })),
  });

  const handleTableExport = () => {
    const message =
      "User click on 'Export' button to download the team tasks controls table";
    trackEvent(message);
    const csvExportOptions = {
      fileName: generateFileName(`team-tasks-controls`),
    };
    gridRef?.current?.exportDataAsCsv(csvExportOptions);
  };

  const filteredControls = useMemo(() => {
    if (!controls) return [];
    return filterTeamTasks(controls);
  }, [controls]);

  const handleViewAll = () => {
    trackEvent("User clicked on 'View All' button in Team Tasks widget");
    navigate("/posture/controls", {
      state: {
        filters: {
          assignee: Object.fromEntries(
            filteredControls.map((control) => [
              control.assignee?.email,
              control.assignee?.email,
            ])
          ),
          controlStatuses: {
            Gap: true,
            Compliant: false,
            Excluded: false,
            Snoozed: false,
          },
        },
      },
    });
  };

  return (
    <WidgetWrapper
      title="Team Tasks"
      onExport={handleTableExport}
      info="Gaps assigned to team members, sorted by severity"
      viewAll={{
        handleViewAll: handleViewAll,
        tooltip: "Go to the full list view",
        newTab: false,
      }}
    >
      {loadingControls ? (
        <LoadingIcon size={12} />
      ) : (
        <ControlsTableWidget
          controls={filteredControls}
          loading={loadingControls}
          refToPass={gridRef}
          columnsToShow={[
            "id",
            "name",
            "tool",
            "severity",
            "affected_entities_count",
            "assignee",
            "ticket",
          ]}
        />
      )}
    </WidgetWrapper>
  );
};

export default TeamTasks;
